import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AlertCircle, CheckCircle } from "lucide-react";

const LoginPage = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });
    setIsLoading(true);

    try {
      const result = await login(credentials.email, credentials.password);
      console.log("Login attempt result:", result);

      if (result.success) {
        setStatus({
          type: "success",
          message: result.message,
        });

        setTimeout(() => {
          const from = location.state?.from?.pathname || "/admin";
          navigate(from, { replace: true });
        }, 1500);
      } else {
        setStatus({
          type: "error",
          message: result.error,
        });
      }
    } catch (err) {
      console.error("Login error:", err);
      setStatus({
        type: "error",
        message: "Login failed. Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear status when user starts typing
    setStatus({ type: "", message: "" });
  };

  return (
    <div className="min-h-screen bg-[#FAF9FF] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-[#0E0444] mb-6 text-3xl font-semibold text-center">
          Admin Login
        </h2>

        {status.message && (
          <div
            className={`mb-6 p-4 rounded-md flex items-center gap-2 ${
              status.type === "error"
                ? "bg-red-50 text-red-600"
                : "bg-green-50 text-green-600"
            }`}
          >
            {status.type === "error" ? (
              <AlertCircle className="h-5 w-5" />
            ) : (
              <CheckCircle className="h-5 w-5" />
            )}
            <span>{status.message}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-[#4C4D5E] text-sm font-medium mb-2"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C60F2] focus:border-transparent"
              required
              autoComplete="email"
              disabled={isLoading}
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-[#4C4D5E] text-sm font-medium mb-2"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C60F2] focus:border-transparent"
              required
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full bg-[#0C60F2] text-white px-4 py-2 rounded-md transition-colors
              ${
                isLoading
                  ? "bg-blue-400 cursor-not-allowed"
                  : "hover:bg-[#0A4ED1]"
              }`}
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Logging in...
              </span>
            ) : (
              "Login"
            )}
          </button>

          <div className="text-sm text-center text-gray-600">
            <p>If you need access, please contact an administrator</p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;

// import React, { useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import { AlertCircle, CheckCircle } from 'lucide-react';

// const LoginPage = () => {
//   const [credentials, setCredentials] = useState({ email: '', password: '' });
//   const [status, setStatus] = useState({ type: '', message: '' });
//   const [isLoading, setIsLoading] = useState(false);
//   const { login } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus({ type: '', message: '' });
//     setIsLoading(true);

//     try {
//       const result = await login(credentials.email, credentials.password);
//       if (result) {
//         setStatus({
//           type: 'success',
//           message: result.message || 'Login successful!'
//         });

//         // Short delay to show success message before navigation
//         setTimeout(() => {
//           const from = location.state?.from?.pathname || '/admin';
//           navigate(from, { replace: true });
//         }, 1500);
//       } else {
//         setStatus({
//           type: 'error',
//           message: result.error || 'Invalid email or password'
//         });
//       }
//     } catch (err) {
//       setStatus({
//         type: 'error',
//         message: 'Login failed. Please try again later.'
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     // Clear status when user starts typing
//     setStatus({ type: '', message: '' });
//   };

//   return (
//     <div className="min-h-screen bg-[#FAF9FF] flex items-center justify-center px-4">
//       <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
//         <h2 className="text-[#0E0444] mb-6 text-3xl font-semibold text-center">
//           Admin Login
//         </h2>

//         {status.message && (
//           <div className={`mb-6 p-4 rounded-md flex items-center gap-2 ${
//             status.type === 'error' ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600'
//           }`}>
//             {status.type === 'error' ? (
//               <AlertCircle className="h-5 w-5" />
//             ) : (
//               <CheckCircle className="h-5 w-5" />
//             )}
//             <span>{status.message}</span>
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label
//               htmlFor="email"
//               className="block text-[#4C4D5E] text-sm font-medium mb-2"
//             >
//               Email
//             </label>
//             <input
//               id="email"
//               type="email"
//               name="email"
//               value={credentials.email}
//               onChange={handleChange}
//               className="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C60F2] focus:border-transparent"
//               required
//               autoComplete="email"
//               disabled={isLoading}
//             />
//           </div>

//           <div>
//             <label
//               htmlFor="password"
//               className="block text-[#4C4D5E] text-sm font-medium mb-2"
//             >
//               Password
//             </label>
//             <input
//               id="password"
//               type="password"
//               name="password"
//               value={credentials.password}
//               onChange={handleChange}
//               className="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C60F2] focus:border-transparent"
//               required
//               autoComplete="current-password"
//               disabled={isLoading}
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={isLoading}
//             className={`w-full bg-[#0C60F2] text-white px-4 py-2 rounded-md transition-colors
//               ${isLoading ? 'bg-blue-400 cursor-not-allowed' : 'hover:bg-[#0A4ED1]'}`}
//           >
//             {isLoading ? (
//               <span className="flex items-center justify-center">
//                 <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                 </svg>
//                 Logging in...
//               </span>
//             ) : (
//               'Login'
//             )}
//           </button>

//           <div className="text-sm text-center text-gray-600">
//             <p>If you need access, please contact an administrator</p>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;
